import { ArrowUpDown, Eye } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../../components/DataTable";
import { Badge } from "../../../components/ui/badge";
import { Button } from "../../../components/ui/button";
import DialogDeleteCourse from "./DialogDeleteCourse";
import { useLanguage } from "../../../context/LanguageContext";
import { CourseData } from "../../../lib/languages";

const TableCourse = ({ data, getAllCourses, subCategory }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = CourseData[language] || CourseData["en"];

  const columns = [
    {
      accessorKey: "title.en",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.titleEn}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ row }) => row.original.title?.en || "---",
    },
    {
      accessorKey: "title.ar",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.titleAr}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ row }) => row.original.title?.ar || "---",
    },
    {
      accessorKey: "created_by.name",
      header: t.createdBy,
    },
    {
      accessorKey: "level_count",
      header: t.levelCount,
    },
    {
      accessorKey: "status",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.status}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ row }) => {
        const status = row.getValue("status");
        return (
          <Badge variant={status ? "default" : "destructive"}>
            {status ? t.active : t.inactive}
          </Badge>
        );
      },
    },
    {
      id: "actions",
      header: t.actions,
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="flex items-center gap-2">
            <Button
              size="icon"
              className="rounded-xl h-9"
              onClick={() =>
                navigate(`/admin/course-view/${item?.id}`, {
                  state: { subCategory },
                })
              }
            >
              <Eye />
            </Button>
            <DialogDeleteCourse
              course={item}
              subCategory={subCategory}
              getAllCourses={getAllCourses}
            />
          </div>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      title={t.coursesByTitle}
      filterNames={["title_ar", "title_en"]}
    />
  );
};

export default TableCourse;
